import {
  PromoUpdateRequest,
  PromoCreateRequest,
  Configuration as PromoConfiguration,
  PromoControllerApiFactory,
} from '@ce-openapi/reactor-promo-ts-axios-client';
import { MOKA_GOAUTH_SERVICE } from 'mf-shared/api/constants';
import {
  BusinessControllerApiFactory,
  Configuration as BusinessConfiguration,
} from '@ce-openapi/promo-view-service-api-documentation-ts-axios-client';

const promoConf = new PromoConfiguration({
  basePath: `${MOKA_GOAUTH_SERVICE}/promo`,
});
const BusinessConf = new BusinessConfiguration({
  basePath: `${MOKA_GOAUTH_SERVICE}/promo`,
});

export const getPromoDetail = (promoId: number) =>
  BusinessControllerApiFactory(BusinessConf).getDetail(promoId);

export const createPromo = (
  promoPayload: PromoCreateRequest,
  reqUuid: string
) => PromoControllerApiFactory(promoConf).create(reqUuid, promoPayload);

export const updatePromo = (
  promoId: number,
  promoPayload: PromoUpdateRequest,
  reqUuid: string
) =>
  PromoControllerApiFactory(promoConf).update(reqUuid, promoId, promoPayload);

export const deletePromo = (promoId: number, reqUuid: string) =>
  PromoControllerApiFactory(promoConf)._delete(reqUuid, promoId);
